import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<p>{{html-safe (trim @question.question)}}</p>\n")